import { render, staticRenderFns } from "./RecommendedBenefit.vue?vue&type=template&id=fa30d6fe&scoped=true"
import script from "./RecommendedBenefit.vue?vue&type=script&lang=js"
export * from "./RecommendedBenefit.vue?vue&type=script&lang=js"
import style0 from "./RecommendedBenefit.vue?vue&type=style&index=0&id=fa30d6fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa30d6fe",
  null
  
)

export default component.exports